import { templateCaches } from '../../../lit-html/lib/template-factory.js';
import { marker, Template } from '../../../lit-html/lib/template.js';

var getTemplateCacheKey = function getTemplateCacheKey(type, scopeName) {
  return "".concat(type, "--").concat(scopeName);
};
var compatibleShadyCSSVersion = true;

// @ts-ignore
var _window = window,
  ShadyCSS = _window.ShadyCSS;
if (typeof ShadyCSS === 'undefined') {
  compatibleShadyCSSVersion = false;
} else if (typeof ShadyCSS.prepareTemplateDom === 'undefined') {
  compatibleShadyCSSVersion = false;
}

/**
 * Template factory which scopes template DOM using ShadyCSS.
 * @param scopeName {string}
 */
var shadyTemplateFactory = function shadyTemplateFactory(scopeName) {
  return function (result) {
    var cacheKey = getTemplateCacheKey(result.type, scopeName);
    var templateCache = templateCaches.get(cacheKey);
    if (templateCache === undefined) {
      templateCache = {
        stringsArray: new WeakMap(),
        keyString: new Map()
      };
      templateCaches.set(cacheKey, templateCache);
    }
    var template = templateCache.stringsArray.get(result.strings);
    if (template !== undefined) {
      return template;
    }
    var key = result.strings.join(marker);
    template = templateCache.keyString.get(key);
    if (template === undefined) {
      var element = result.getTemplateElement();
      if (compatibleShadyCSSVersion) {
        ShadyCSS.prepareTemplateDom(element, scopeName);
      }
      template = new Template(result, element);
      templateCache.keyString.set(key, template);
    }
    templateCache.stringsArray.set(result.strings, template);
    return template;
  };
};

export { shadyTemplateFactory };
